<template>
  <v-container fluid class="holiday-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
        >
          <v-tab
            :href="`#tab-holiday`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-calendar-month</v-icon>
            Holiday
          </v-tab>
          <v-tab-item
            :value="'tab-holiday'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">Edit Holiday</p>
                      <v-menu
                        ref="menu_holidaydate"
                        v-model="menu_holidaydate"
                        :close-on-content-click="false"
                        :return-value.sync="holidaydate"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            outlined
                            dense
                            persistent-hint
                            v-model="holidaydate"
                            label="Holiday Date"
                            v-bind="attrs"
                            v-bind:value="holidaydate"
                            v-on:change="updateChangedValue($event, 'holidaydate')"
                            v-on="on"
                            single-line
                            hint="Please choose the holiday date"
                          >
                            ></v-text-field
                          >
                        </template>
                        <v-date-picker
                          v-model="holidaydate"
                          no-title
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="menu_holidaydate = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="updateChangedValue(holidaydate,'holidaydate');$refs.menu_holidaydate.save(holidaydate);"                   
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'holidaycode')"
                        v-bind:value="initvalue.holidaycode"
                        placeholder="Holiday Code"
                        persistent-hint
                        single-line hint="Enter the holiday code">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'holidayname')"
                        v-bind:value="initvalue.holidayname"
                        placeholder="Holiday Name"
                        persistent-hint
                        single-line hint="Enter the holiday name">
                      </v-text-field>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'holidaynameinfo')"
                        v-bind:value="initvalue.holidayinfo"
                        placeholder="Holiday Info"
                        persistent-hint
                        single-line hint="Enter the holiday info">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items=holidaytype
                        :value="initvalue.holidaytype"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'holidaytype')"
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the holiday type">
                      </v-select>
                      <v-switch
                          color="primary"
                          v-on:change="updateChangedValue($event, 'holidaystatus')"
                          v-bind:label="initvalue.holidaystatus"
                          v-model="initvalue.holidaystatus"
                          value="Active"
                      ></v-switch>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col>
                    <div class="d-flex justify-center">
                        <v-btn
                            to="/holiday/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="updateHoliday()">
                            Save
                          </v-btn>
                      </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import { formatStdDate } from '@/mixins/date';
import router from '@/Routes';

export default {
  data () {
    return {
      holiday: {},
      initvalue: {},
      holidaytype: ['Holiday'],
      menu_holidaydate: null,
      holidaydate: null,
    }
  },
  methods: {
    ...mapActions('Holiday', ['getHolidaysRequest', 'updateHolidayRequest',]),
    updateHoliday() {
      this.holiday._id = this.initvalue._id;
      this.updateHolidayRequest(this.holiday);
      this.getHolidaysRequest();
      router.push('/holiday/list');
    },
    updateChangedValue(value, field){
      this.holiday[field] = value;
    },
  },
  computed: {
    ...mapState('Holiday', ['isReceiving'])
  },
  created () {
    this.initvalue = this.$route.params;
    if(!this.initvalue._id) this.$router.push({ name: 'HolidayList' });
    this.holidaydate = formatStdDate(this.initvalue.holidaydate);
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
